import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { JobShipmentInfoEntity } from '../../domain/entities/JobShipmentInfoEntity'
import type { JobShipmentInfoDtoAdmin } from '@/backend/market'
export class JobShipmentInfoModel extends JobShipmentInfoEntity {
  constructor(dataDto: JobShipmentInfoDtoAdmin) {
    super()
    mapEntityProperties<JobShipmentInfoEntity>(this, dataDto)
  }
}
